import { render, staticRenderFns } from "./newGame.vue?vue&type=template&id=10e435aa&scoped=true"
import script from "./newGame.vue?vue&type=script&lang=js"
export * from "./newGame.vue?vue&type=script&lang=js"
import style1 from "./newGame.vue?vue&type=style&index=1&id=10e435aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e435aa",
  null
  
)

export default component.exports